import React, { FC } from 'react';

import { ControlledMultiSelect, SelectAll } from './MultiSelect';
import StyledSelect from './StyledSelect';

interface Option {
  id: string | number;
  value: string;
  label: unknown;
}

interface StyledSelectContainerProps {
  canSelectAll?: boolean;
  isMulti?: boolean;
  options: Option[];
}

export const StyledSelectContainer: FC<StyledSelectContainerProps> = props => {
  if (props.isMulti) {
    // `SelectAll` derives its extra row from `options[0]`, so an empty list has
    // nothing for it to build one from. The multi control itself has no such
    // floor, and an account whose list is empty still renders the values a
    // stored record holds — so only the select-all half is withheld.
    if (props.canSelectAll && props.options.length > 0) {
      return <SelectAll {...props} />;
    }

    return <ControlledMultiSelect {...props} />;
  }

  return (
    // @ts-expect-error this should go away when converting `StyledSelect`
    <StyledSelect {...props} />
  );
};

export default StyledSelectContainer;
